import {all, call, put, takeEvery, takeLeading} from "@redux-saga/core/effects";
import {RouteService} from '../../services/route';
import {locationActions} from "./reducer";
import {PoiService} from "../../services/poi";
import {IPois} from "../../varibles/interface";
import {showErrorResponse} from "../../varibles/global";


function* getLocationsWatcher(): Generator<any, any, IPois[]> {
    try {
        const locations = yield call(PoiService.gets);
        yield put(locationActions.getPoisSuccess(locations));
    } catch (error) {
        yield put(locationActions.getPoisFailure())
        showErrorResponse('Get locations failure', error);
    }
}


function* getRouteLocationsWatcher(): Generator<any, any, IPois[]> {
    try {
        const locations = yield call(RouteService.getLocations);
        yield put(locationActions.getLocationsSuccess(locations));
    } catch (error) {
        yield put(locationActions.getLocationsFailure());
        showErrorResponse('Get locations failed', error);
    }
}

function* getAllLocationsWatcher(): Generator<any, any, IPois[]> {
    try {
        const locations = yield call(RouteService.getAllLocations);
        yield put(locationActions.getAllLocationsSuccess(locations));
    } catch (error) {
        yield put(locationActions.getAllLocationsFailure());
        showErrorResponse('Get locations failed', error);
    }
}

export default function* locationSaga() {
    yield all([
        takeEvery(locationActions.getPois.type, getLocationsWatcher),
        takeLeading(locationActions.getLocationsRequest.type, getRouteLocationsWatcher),
        takeLeading(locationActions.getAllLocationsRequest.type, getAllLocationsWatcher),
    ])
}
